/**
 * @generated SignedSource<<25d9416181f351a6e7d91585f013be46>>
 * @relayHash 16e67bdebc300ecfa4c211dc75c0ca88
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 16e67bdebc300ecfa4c211dc75c0ca88

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CriticalityLevel = "CRITICAL" | "INFO" | "WARNING";
export type DisplayFor = "CALL_CENTER_AGENT" | "CUSTOMER_SERVICE_CENTER" | "DOCTOR" | "NONE" | "NURSING_PROFESSIONAL";
export type CreateNewsInput = {
  criticalityLevel: CriticalityLevel;
  displayFor: ReadonlyArray<DisplayFor>;
  endTime?: string | null;
  englishContent: string;
  frenchContent?: string | null;
  germanContent: string;
  italianContent?: string | null;
  startTime: string;
};
export type useCreateNewsMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateNewsInput;
};
export type useCreateNewsMutation$data = {
  readonly createNews: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly news: {
      readonly id: string;
      readonly isShowing: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"NewsFragment">;
    } | null;
  };
};
export type useCreateNewsMutation = {
  response: useCreateNewsMutation$data;
  variables: useCreateNewsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isShowing",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateNewsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "CreateNewsPayload",
        "kind": "LinkedField",
        "name": "createNews",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "News",
            "kind": "LinkedField",
            "name": "news",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NewsFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useCreateNewsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "CreateNewsPayload",
        "kind": "LinkedField",
        "name": "createNews",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "News",
            "kind": "LinkedField",
            "name": "news",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "criticalityLevel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "englishContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "germanContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frenchContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "italianContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayFor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "news",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "NewsEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "16e67bdebc300ecfa4c211dc75c0ca88",
    "metadata": {},
    "name": "useCreateNewsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ada35440aa487d6c5b67599c0dec23e8";

export default node;
